// @ts-nocheck
/* eslint-disable */
export const lineItemsIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 19H18L14.5 16H14.0616C12.7604 16 11.8057 14.7772 12.1213 13.5149C12.3439 12.6246 13.1438 12 14.0616 12H14.1391C15.375 12 16.315 13.1097 16.1119 14.3288L16 15L19 17.5V5H14L10.5 8.5V8.75C10.5 9.7165 9.7165 10.5 8.75 10.5C7.7835 10.5 7 9.7165 7 8.75C7 7.7835 7.7835 7 8.75 7H9.5L11.5 5H5V19Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'line-items' as const,
};
